<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
         <div class="d-flex align-items-center">
            <h1 class="page-heading">
                <svg width="36" height="29" viewBox="0 0 36 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_679_2720)">
                    <path d="M30.0547 0H5.94526C4.88421 0 4 0.820629 4 1.80538V18.7377C4 19.7224 4.88421 20.5431 5.94526 20.5431H30.0547C31.1158 20.5431 32 19.7224 32 18.7377V1.80538C32 0.793275 31.1158 0 30.0547 0ZM12.3116 1.86009C12.7832 1.86009 13.1368 2.2157 13.1368 2.62601C13.1368 3.06368 12.7537 3.39193 12.3116 3.39193C11.84 3.39193 11.4863 3.03633 11.4863 2.62601C11.4568 2.18834 11.84 1.86009 12.3116 1.86009ZM9.77684 1.86009C10.2484 1.86009 10.6021 2.2157 10.6021 2.62601C10.6021 3.06368 10.2189 3.39193 9.77684 3.39193C9.30526 3.39193 8.95158 3.03633 8.95158 2.62601C8.9221 2.18834 9.30526 1.86009 9.77684 1.86009ZM7.21263 1.86009C7.68421 1.86009 8.03789 2.2157 8.03789 2.62601C8.03789 3.06368 7.65474 3.39193 7.21263 3.39193C6.77053 3.39193 6.38737 3.03633 6.38737 2.62601C6.38737 2.18834 6.77053 1.86009 7.21263 1.86009ZM29.4947 18.0538C29.4947 18.1359 29.4358 18.1906 29.3474 18.1906H6.65263C6.56421 18.1906 6.50526 18.1359 6.50526 18.0538V5.27938H29.4947V18.0538Z" fill="#265D91"/>
                    <path d="M10.7766 12.8291H13.7829C14.1956 12.8291 14.5787 12.6376 14.785 12.282L15.8756 10.5587L19.0882 15.5646C19.2945 15.8928 19.6777 16.1116 20.0903 16.1116C20.5029 16.1116 20.8861 15.9202 21.0924 15.5646L22.8608 12.8018H25.1892C25.8377 12.8018 26.3682 12.3094 26.3682 11.7076C26.3682 11.1058 25.8377 10.6134 25.1892 10.6134H22.2124C21.7998 10.6134 21.4166 10.8049 21.2103 11.1605L20.1198 12.8838L16.9071 7.878C16.4945 7.22149 15.3156 7.22149 14.8734 7.878L13.105 10.6408H10.7766C10.1282 10.6408 9.59766 11.1332 9.59766 11.735C9.59766 12.3367 10.1282 12.8291 10.7766 12.8291Z" fill="#265D91"/>
                    </g>
                    <defs>
                    <filter id="filter0_d_679_2720" x="0" y="0" width="36" height="28.5431" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="4"/>
                    <feGaussianBlur stdDeviation="2"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_679_2720"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_679_2720" result="shape"/>
                    </filter>
                    </defs>
                    </svg>
                    
                
                CRA
            </h1>
                <!--begin::Menu-->
         </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                  </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">CRA</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Workflow</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-15">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

          <div class="card-body">
          
     <div class="table-container" [formGroup]="formWorkFlow">
        <div class="table-responsive" formArrayName="subWorkFlows">
            <table class="table workflow" >
                <thead>
                    <tr>
                        <th class="min-w-125px">Etape</th>
                        <th class="min-w-125px">Nom</th>
                        <th class="min-w-125px">Status</th>
                        <!-- <th class="min-w-125px">Action</th> -->
                    
                    </tr>
                </thead>
                <tbody  *ngFor="let subWorkFlows of subWorkFlowsControls; let i = index">
                   
                    <tr [formGroupName]="i">
                      
                        <td>
                            <span class="index">1</span>
                        </td>
                        <td>
                         
                            <ng-select  class="form-select form-select-sm form-select-solid" [items]="name" bindLabel="name" bindValue="id"
                            formControlName="name" [placeholder]="'Select poste'" autoComplete>
                        </ng-select>
                            <!-- <select formControlName="name" name="Nom" aria-label="Select poste" data-control="select2"  class="form-select form-select-sm form-select-solid">
                                <option value="1">Responsable</option>
                                <option value="2">Consultant</option>
                                <option value="3">RH</option>
                            </select> -->
                        </td>
                        <td>
                            <!-- <select class="form-select form-select-sm form-select-solid"  data-kt-select2="true" aria-label="Select status" >
                                <option value="1">Validé</option>
                                <option value="2">Rejeté</option>
                            </select> -->
                            <ng-select  class="form-select form-select-sm form-select-solid" [items]="state" bindLabel="name" bindValue="id"
                            formControlName="state" [placeholder]="'Select status'" autoComplete>
                        </ng-select>
                        </td>
                        <!-- <td>
                        <div (click)="addsubWorkFlows()">
                            <img src="/assets/media/icons/icon-add.png" alt="addIcon" width="20"
                                class="addIcon">
                        </div>
                     </td> -->
             
                    </tr>
                </tbody>
            </table>
           
           </div>
     </div>
       <div class="add-row buttons mt-10 mb-10" style="text-align: right;">
        <button (click)="ResetForm()" class="annuler">Annuler</button>
        <button  class="save" (click)="createWorkflow()">Enregistrer</button>
    </div>
          </div>
        </div>

    </div>
    <!--end::Content container-->
</div>

